import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Budget } from "../state/types"

export const useBudgetActions = () => {
    const saveActions = useSaveActions()

    const saveBudget = (budget: Budget) => {
        const { save } = saveActions()
        return save(TableName.BUDGETS, budget) as Promise<Budget>
    }

    const removeBudget = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.BUDGETS, id)
    }

    return {
        saveBudget,
        removeBudget
    }
}
